/**
 * Generated runtime TestId mirror for frontend/src/pages/JobDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const JobDetailTestIds = {
  btnCancelRemoveSchedule: "btn-cancel-remove-schedule",
  btnConfirmRemoveSchedule: "btn-confirm-remove-schedule",
  btnDeleteJob: "btn-delete-job",
  btnEditSchedule: "btn-edit-schedule",
  btnEditTasks: "btn-edit-tasks",
  btnRunNow: "btn-run-now",
  btnScheduleCancel: "btn-schedule-cancel",
  btnScheduleSave: "btn-schedule-save",
  inputCron: "input-cron",
  jobDetailTitle: "job-detail-title",
  linkViewAllExecutions: "link-view-all-executions",
  scheduleEditForm: "schedule-edit-form",
  sectionConfiguration: "section-configuration",
  sectionRecentExecutions: "section-recent-executions",
  sectionTasks: "section-tasks",
  selectLogLevel: "select-log-level",
  switchEnabled: "switch-enabled",
  btnToggleFullScript: (task_id: string) => `btn-toggle-full-script-${task_id}`,
  btnToggleFullScriptPrefix: () => "btn-toggle-full-script-" as TestIdPrefix,
  btnToggleScript: (task_id: string) => `btn-toggle-script-${task_id}`,
  btnToggleScriptPrefix: () => "btn-toggle-script-" as TestIdPrefix,
  execRow: (exec_id: string) => `exec-row-${exec_id}`,
  execRowPrefix: () => "exec-row-" as TestIdPrefix,
  linkEditInBuilder: (task_id: string) => `link-edit-in-builder-${task_id}`,
  linkEditInBuilderPrefix: () => "link-edit-in-builder-" as TestIdPrefix,
  scriptPreview: (task_id: string) => `script-preview-${task_id}`,
  scriptPreviewPrefix: () => "script-preview-" as TestIdPrefix
} as const;
